module.exports = __webpack_public_path__ + "static/media/cart.542b61da.svg";